import type { Timestamp } from '../types'

export type Change = {
  type: string
  title: string
  description: string
}

export type Version = {
  number: string
  timestamp: Timestamp
  changes: Array<Change>
}

export type TypedChange = (title: string, description: string) => Change

export const version = (number: string, timestamp: string, changes: Array<Change>): Version => ({
  number,
  timestamp,
  changes,
})

export const changeType =
  (type: string) =>
  (title: string, description: string): Change => ({
    type,
    title,
    description,
  })

export const newFeature: TypedChange = changeType('new-feature')
export const featureChange: TypedChange = changeType('change')
export const bugfix: TypedChange = changeType('bugfix')
